module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    attrs: {
      "size": "lg",
      "id": "usersModal",
      "hide-footer": "",
      "no-close-on-backdrop": "",
      "hide-header-close": "",
      "centered": ""
    }
  }, [(_vm.action.action === 'createUser') ? _c('CreateUser', {
    attrs: {
      "action": _vm.action
    }
  }) : _vm._e(), _vm._v(" "), (_vm.action.action === 'deleteBrand') ? _c('DeleteBrand', {
    attrs: {
      "action": _vm.action
    }
  }) : _vm._e(), _vm._v(" "), (_vm.action.action === 'changeAccess') ? _c('ChangeAccess', {
    attrs: {
      "action": _vm.action
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8510862c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/users/modal/Modal.vue
// module id = 3301
// module chunks = 0